/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Site_NameInputs */

const en_site_name = /** @type {(inputs: Site_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crazy Frog AI`)
};

const es_site_name = /** @type {(inputs: Site_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crazy Frog AI`)
};

/**
* | output |
* | --- |
* | "Crazy Frog AI" |
*
* @param {Site_NameInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const site_name = /** @type {((inputs?: Site_NameInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Site_NameInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_site_name(inputs)
	return es_site_name(inputs)
});